export const requiredPermission = 'lexio:user';

const decodeBase64Url = (segment) => {
  try {
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    if (typeof atob === 'function') {
      return atob(padded);
    }
    if (typeof Buffer !== 'undefined') {
      return Buffer.from(padded, 'base64').toString('utf-8');
    }
  } catch (err) {
    console.warn('Failed to decode base64 JWT segment', err);
  }
  return null;
};

export function parsePermissionsFromAccessToken(accessToken) {
  if (!accessToken) return null;
  const parts = accessToken.split('.');
  if (parts.length < 2) return null;

  const payloadJson = decodeBase64Url(parts[1]);
  if (!payloadJson) return null;

  try {
    const payload = JSON.parse(payloadJson);
    const permissions = [];

    if (Array.isArray(payload.permissions)) {
      permissions.push(...payload.permissions.filter((p) => typeof p === 'string'));
    }

    return permissions;
  } catch (err) {
    console.warn('Failed to parse JWT payload', err);
    return null;
  }
}

export function userHasRequiredPermission(permissions) {
  if (!Array.isArray(permissions)) return false;
  return permissions.some(
    (permission) =>
      typeof permission === 'string' && permission.toLowerCase() === requiredPermission,
  );
}
